var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerticalTabActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4716",
    "data-name": "Group 4716",
    transform: "translate(21140 14592)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun-ipad-1497748",
    transform: "translate(-21134.6 -14561.867) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13086",
    "data-name": "Path 13086",
    d: "M26.5,16H1.767A1.772,1.772,0,0,0,0,17.767V35.433A1.772,1.772,0,0,0,1.767,37.2H26.5a1.772,1.772,0,0,0,1.767-1.767V17.767A1.772,1.772,0,0,0,26.5,16Zm.883,19.433a.886.886,0,0,1-.883.883H1.767a.886.886,0,0,1-.883-.883V17.767a.886.886,0,0,1,.883-.883H26.5a.886.886,0,0,1,.883.883Z",
    transform: "translate(0 -16)",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13087",
    "data-name": "Path 13087",
    d: "M9.325,57a1.325,1.325,0,1,0,1.325,1.325A1.329,1.329,0,0,0,9.325,57Zm0,2.208a.883.883,0,1,1,.883-.883A.886.886,0,0,1,9.325,59.208Z",
    transform: "translate(-6.233 -47.946)",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_401",
    "data-name": "Ellipse 401",
    cx: 0.473,
    cy: 0.473,
    r: 0.473,
    transform: "translate(25.426 10.41)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13088",
    "data-name": "Path 13088",
    d: "M42.991,24H24.442a.443.443,0,0,0-.442.442V41.224a.443.443,0,0,0,.442.442H42.991a.443.443,0,0,0,.442-.442V24.442A.443.443,0,0,0,42.991,24Zm0,17.224H24.442V24.442H42.991Z",
    transform: "translate(-18.7 -22.233)",
    stroke: "#fff",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1330",
    "data-name": "Rectangle 1330",
    width: 32,
    height: 32,
    transform: "translate(-21140 -14592)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerticalTabActive);
export default __webpack_public_path__ + "static/media/vertical-tab-active.beb977f9da7e7ee7149955e08b41ce3e.svg";
export { ForwardRef as ReactComponent };